import { render, staticRenderFns } from "./dfDate.vue?vue&type=template&id=c96a70f2&scoped=true"
import script from "./dfDate.vue?vue&type=script&lang=js"
export * from "./dfDate.vue?vue&type=script&lang=js"
import style0 from "./dfDate.vue?vue&type=style&index=0&id=c96a70f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96a70f2",
  null
  
)

export default component.exports